import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const BrandingTab = () => {
  const [businessInfo, setBusinessInfo] = useState(null); // Initialize as null to handle loading state
  const user = JSON.parse(localStorage.getItem('user'));

  // Fetch business info when the component mounts
  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/businessInfo/${user.business_id}`);
        console.log('Fetched Business Info:', response.data);
        setBusinessInfo(response.data); // Ensure the response contains the `id` field
      } catch (error) {
        console.error('Failed to fetch business info:', error);
        toast.error('Failed to load business info.');
      }
    };

    fetchBusinessInfo();
  }, []);

  // Handle file upload
  const handleFileChange = async (field, file) => {
    if (!businessInfo || !businessInfo.id) {
      toast.error('Business info is not loaded yet.');
      return;
    }
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('field', field);
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/businessInfo/upload/${user.business_id}`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
  
      console.log('Upload Response:', response.data);
  
      setBusinessInfo((prev) => ({
        ...prev,
        [field]: response.data.data?.[field] || prev[field], // Update only the specific field
      }));
  
      toast.success(`${field} updated successfully!`);
    } catch (error) {
      console.error('File upload error:', error);
      toast.error(`Failed to update ${field}.`);
    }
  };
  
  

  // Handle color update
  const handleColorChange = async (field, value) => {
    if (!businessInfo || !businessInfo.id) {
      toast.error('Business info is not loaded yet.');
      return;
    }
  
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/businessInfo/${user.business_id}`,
        { [field]: value } // Send as { primary_color: "#3b76b5" }
      );
  
      console.log('Color Update Response:', response.data);
  
      setBusinessInfo((prev) => ({
        ...prev,
        [field]: response.data?.data?.[field] || prev[field],
      }));
  
      toast.success(`${field} updated successfully!`);
    } catch (error) {
      console.error('Error updating color:', error);
      toast.error(`Failed to update ${field}.`);
    }
  };
  
  

  // Handle loading state
  if (!businessInfo) {
    return <div>Loading business info...</div>;
  }

  return (
    <div className="h-[800px] overflow-scroll">
      <h2 className="text-xl">Branding</h2>

      {['logo_url', 'auth_logo_url', 'favicon_url'].map((field) => (
        <div key={field} className="grid grid-cols-2 gap-10 w-full">
          <h2>{field.replace('_url', '').replace('_', ' ')}</h2>
          <div className="flex-col gap-4 m-4 p-4">
            <img
              src={businessInfo[field] || 'https://via.placeholder.com/150'}
              className="max-w-sm rounded-lg shadow-xl"
              alt={field}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(field, e.target.files[0])}
              className="btn m-4"
            />
          </div>
        </div>
      ))}

      {['primary_color', 'secondary_color'].map((field) => (
        <div key={field} className="grid grid-cols-2 gap-10 w-full">
          <h2>{field.replace('_', ' ')}</h2>
          <div className="flex gap-4 m-4 p-4">
            <input
              type="color"
              value={businessInfo[field]}
              onChange={(e) => handleColorChange(field, e.target.value)}
              className="w-52 h-4 border-none"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BrandingTab;
